export default __webpack_public_path__ + "b4692b997b816e57fae5838909763fa7.png";